import { ServicePackageClient } from "../services/ohl.virtualCenter.api";

const apiClient = new ServicePackageClient(process.env.REACT_APP_PUBLIC_API);

class ServicePackagesProvider {

    getOne = (resource, params) => {
        return apiClient.servicePackageGet(params.id).then((data) => {
            return { data }
        });
    }

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        
        return apiClient.list({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }

    update = (resource, params) => {
        return apiClient.servicePackagePut(params.data).then((data) => ({
            data
        }));
    }

    create = (resource, params) => {
        return apiClient.servicePackagePost(params.data).then((data) => ({
            data
        }));
    }

    delete = (resource, params) => {
        return apiClient.servicePackageDelete(params.id).then(() => ({
            data: params.previousData
        }));
    }
};

export default new ServicePackagesProvider();